import apiFetch from 'api/base'
import { AxiosPromise } from 'axios'

const URL = `/static/blacklist-mails-domains`

const getEmailsBlackList = (): AxiosPromise => apiFetch(URL, { method: `GET` })

export default getEmailsBlackList
